import React from "react";
import "./MobileMenu.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Purebrand } from "assets/images";

const MobileMenu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const handleBusinessSignup = () => {
    window.location.href = "https://apps.shopify.com/purebrand?search_id=5c43b5ca-bc55-46f1-b480-117255639a1b&surface_detail=Purebrand&surface_inter_position=1&surface_intra_position=1&surface_type=search";
    onClose();
  };

  const isBusinessPage = location.pathname === '/business';

  return (
    <>
      <div className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />

      <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <img
            src={Purebrand}
            alt="Purebrand"
            className="mobile-menu-logo"
            onClick={() => handleNavigation('/')}
          />
          <button className="mobile-menu-close" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>

        <nav className="mobile-menu-nav">
          {/* <div className="mobile-nav-section">
            <a
              className={`mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={() => handleNavigation('/')}
            >
              For Hosts
            </a>
            <a
              className={`mobile-nav-link ${location.pathname === '/business' ? 'active' : ''}`}
              onClick={() => handleNavigation('/business')}
            >
              For Businesses
            </a>
          </div> */}

          {/* <div className="mobile-menu-divider"></div> */}

          <div className="mobile-auth-section">
            {isBusinessPage ? (
              <>
                <button
                  className="mobile-auth-btn mobile-signup-btn"
                  onClick={handleBusinessSignup}
                >
                  Get Started
                </button>
                <button
                  className="mobile-auth-btn mobile-login-btn"
                  onClick={handleBusinessSignup}
                >
                  Log in to Dashboard
                </button>
              </>
            ) : (
              <>
                <button
                  className="mobile-auth-btn mobile-signup-btn"
                  onClick={() => handleNavigation('/signup')}
                >
                  Sign up
                </button>
                <button
                  className="mobile-auth-btn mobile-login-btn"
                  onClick={() => handleNavigation('/login')}
                >
                  Log in
                </button>
              </>
            )}
          </div>

          <div className="mobile-menu-divider"></div>

          <div className="mobile-nav-section mobile-footer-links">
            <a onClick={() => handleNavigation('/privacy-policy')}>
              Privacy Policy
            </a>
            <a onClick={() => handleNavigation(`/terms-and-conditions${isBusinessPage ? '?business=true' : ''}`)}>
              Terms & Conditions
            </a>
            <a onClick={() => handleNavigation('/support')}>
              Support
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default MobileMenu;